<template>
    <Card :title="$route.meta.title" dis-hover>
        <div slot="extra">

        </div>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <Input v-model="query.adminUser" placeholder="管理员账号"></Input>
            </FormItem>
            <FormItem>
                <Input v-model="query.departmentName" placeholder="组织名称"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
            <Button type="success" icon="md-add" @click="handleOperation(null,'ADD')">
                添加
            </Button>
        </Form>
        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <!--<template slot-scope="{row}" slot="places">
                <template v-if="row.places.length > 0">
                    <Tag v-for="(item,index) in row.places" color="green" :key="index">
                        {{item.placeName}}
                    </Tag>
                </template>
                <Tag v-else-if="row.superAdmin==1" color="green">所有地区</Tag>
                <Tag v-else color="silver">暂无授权地区</Tag>
            </template>-->
            <template slot-scope="{row}" slot="place">
                {{row.place?row.place.placeName:'无'}}
            </template>
            <template slot-scope="{row}" slot="operation">
                <!--<a v-if="row.superAdmin != 1" class="opt-txt" @click="handleOperation(row,'AUTH')">修改授权地区</a>-->
                <a v-if="row.superAdmin != 1" class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>
        <Modal v-model="modalVisible" :title="modalTitle">
            <Spin size="large" fix v-if="modalLoading"></Spin>
            <Form ref="baseForm" :model="modalForm" :label-width="100">
                <FormItem label="组织名称" prop="departmentName" :rules="[rules.required]">
                    <Input v-model="modalForm.departmentName" placeholder="组织名称"></Input>
                </FormItem>
                <FormItem label="归属地区" prop="place.id" :rules="[rules.requiredNumber]">
                    <place-sel v-model="modalForm.place.id" placeholder="归属地区"></place-sel>
                </FormItem>
                <FormItem label="联系人" prop="contacter" :rules="[rules.required]">
                    <Input v-model="modalForm.contacter" placeholder="联系人"></Input>
                </FormItem>
                <FormItem label="手机号" prop="mobile" :rules="[rules.required]">
                    <Input v-model="modalForm.mobile" placeholder="手机号"></Input>
                </FormItem>
                <FormItem label="地址" prop="address" :rules="[rules.required]">
                    <Input v-model="modalForm.address" placeholder="地址"></Input>
                </FormItem>
                <FormItem label="管理员账号" prop="adminUser" :rules="[rules.required]">
                    <Input v-model="modalForm.adminUser" placeholder="管理员账号"></Input>
                </FormItem>
                <FormItem label="角色" prop="adminRole.id" :rules="[rules.requiredNumber]">
                    <role-sel v-model="modalForm.adminRole.id" placeholder="角色" :roleType="1"></role-sel>
                </FormItem>
                <FormItem label="管理员密码" prop="adminPassword" :rules="[rules.required]">
                    <Input type="password" v-model="modalForm.adminPassword" placeholder="管理员密码"></Input>
                </FormItem>
                <FormItem label="确认密码" prop="adminPasswordConfirm" :rules="[rules.required]">
                    <Input type="password" v-model="modalForm.adminPasswordConfirm" placeholder="确认密码"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
        </Modal>

        <Drawer title="地区" placement="right" width="360" :closable="false" v-model="drawerVisible">
            <Spin size="large" fix v-if="drawerLoading"></Spin>
            <Tree ref="placeTree" :data="placeTreeList" show-checkbox
                  @on-select-change="(select,row)=>{row.selected=false}"></Tree>
            <div class="drawer-footer">
                <Button style="margin-right: 8px" @click="drawerVisible = false">取消</Button>
                <Button type="primary" @click="handleAuthSubmit">确定</Button>
            </div>
        </Drawer>
    </Card>
</template>

<script>
    import iSetting from '@/module/base/api/iSetting'
    import tableHelper from '@/mixins/tableHelper';
    import PlaceSel from '@/module/main/components/PlaceSel';
    import RoleSel from '@/module/main/components/RoleSel';
    import rules from '@/libs/rules';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id: null,
        departmentType:0,
        departmentName: null,
        epaType:1,
        place:{id:null},
        contacter: null,
        mobile: null,
        address: null,
        adminUser: null,
        adminPassword:null,
        adminPasswordConfirm:null,
        adminRole:{id:null},
        places:[]
    };

    export default {
        name: "depart_mng",
        mixins: [tableHelper],
        components: {
            PlaceSel,RoleSel
        },
        data() {
            return {
                rules,
                tableColumns: [
                    {title: '序号', key: 'idx', width: 80},
                    {title: '组织名称', key: 'departmentName', width: 200},
                    {title: '联系人', key: 'contacter'},
                    {title: '联系电话', key: 'mobile'},
                    {title: '归属地区', slot: 'place'},
                    {title: '管理员账号', key: 'userName', width: 120},
                    {title: '添加时间', key: 'addTime', width: 180},
                    /*{title: '授权地区', slot: 'places'},*/
                    {title: '操作', slot: 'operation', width: 200}
                ],
                modalVisible: false,
                modalTitle: '添加组织',
                modalLoading:false,
                modalForm: _don.cloneWithModal(modalFormTemplate),

                drawerVisible:false,
                drawerLoading:false,
                placeTreeList:[],

                query:{
                    departmentName:null,
                    adminUser:null
                }
            }
        },
        async mounted() {
            iSetting.placeList(1).then(res => {
                this.placeTreeList = this.processTreeData(res)
            });
            this.getTableData();
        },
        methods: {
            getTableData() {
                iSetting.departList(this.page, this.query).then(data => {
                    var i = 1
                    this.tableList = data.content.map(e => {
                        let d = e.department
                        e.id = d.id
                        e.departmentName = d.departmentName
                        e.places = d.places
                        e.departAddTime = d.addTime
                        e.place = d.place
                        e.contacter = d.contacter
                        e.mobile = d.mobile
                        e.idx = (this.page.page-1)*this.page.size+i++
                        return e
                    });
                    this.total = data.totalElements;
                }).loadingSwitch(this, 'tableLoading');
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.$refs.baseForm.resetFields();
                    this.modalVisible = true
                    this.modalForm = _don.cloneWithModal(modalFormTemplate)
                    return;
                }
                if (type === 'AUTH') {
                    this.drawerVisible = true;
                    for (let key of Object.keys(this.modalForm)) {
                        this.modalForm[key] = row[key]
                    }
                    this.resetAuthPlaceTree(this.modalForm.places, this.placeTreeList);
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `该操作将删除组织“${row.departmentName}”，确认继续？`,
                        onOk: () => {
                            iSetting.departDelete(row.department.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
            },
            resetAuthPlaceTree(authArr, list) {
                for (let place of list) {
                    if (place.children && place.children.length > 0) {
                        place.checked = false;
                        place.indeterminate = authArr.some(e => e.id === place.id);
                        this.resetAuthPlaceTree(authArr, place.children);
                    } else {
                        place.checked = authArr.some(e => e.id === place.id);
                    }
                }
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    if (this.modalForm.adminPassword != this.modalForm.adminPasswordConfirm) {
                        this.$Message.error('两次输入的密码不一致')
                        return
                    }
                    iSetting.departAdd(this.modalForm).then(() => {
                        this.$Message.success('操作成功');
                        this.getTableData()
                        this.modalVisible = false
                    });
                });
            },
            handleAuthSubmit() {
                this.modalForm.places = this.$refs['placeTree'].getCheckedAndIndeterminateNodes();
                iSetting.departUpdateAuth(this.modalForm).then(() => {
                    this.getTableData()
                    this.drawerVisible = false;
                    this.$Message.success('操作成功');
                }).loadingSwitch(this, 'drawerLoading');
            },
            processTreeData(places) {
                return places.map(e => {
                    e.title = e.placeName
                    e.expand = true,
                    e.checked =  false,
                    e.indeterminate =  false,
                    e.children = this.processTreeData(e.children)
                    return e
                });
            }
        },
        watch: {
            $route(to) {
                /*if (to.name === this.$options.name) {
                    this.getTableData();
                }*/
            }
        }
    }
</script>

<style scoped>

</style>
